import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { discussions } from "@/mocks/home";

const communityStats = [
  { label: "今日新帖", value: "128" },
  { label: "活跃整理者", value: "1,940" },
  { label: "本周回复", value: "3,260" },
];

export default function DiscussionSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [postHint, setPostHint] = useState("");

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePost = () => {
    setPostHint("发帖入口为演示效果，正式上线后可在此提交整理线索");
    window.setTimeout(() => setPostHint(""), 2600);
  };

  return (
    <section id="discussion" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <SectionHeading
          id="discussion"
          kicker="讨论区"
          title="一起整理、互相纠错的讨论氛围"
          desc="这里不只是查阅入口，也是大家交换主题线索、补充资料出处的地方。看到想跟进的帖子，点个赞就能回到讨论里。"
          actionLabel="进入讨论区"
          actionHref="#subscribe"
          actionIcon="ri-chat-3-line"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {discussions.map((item) => (
                <li
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <div className="flex items-start gap-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                      {item.avatar}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-[11px] font-medium text-primary-700">
                          {item.tag}
                        </span>
                        <span className="font-label text-xs text-foreground-500">{item.time}</span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950">
                        <a href="#discussion" className="cursor-pointer hover:text-primary-700">
                          {item.title}
                        </a>
                      </h3>
                      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 font-label text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-user-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {item.author}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-1-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {item.replies} 条回复
                        </span>
                        <button
                          type="button"
                          onClick={() => toggleLike(item.id)}
                          className={`flex items-center gap-1 whitespace-nowrap transition-colors ${
                            liked[item.id] ? "text-primary-600" : "hover:text-primary-600"
                          }`}
                        >
                          <i
                            className={`${
                              liked[item.id] ? "ri-heart-fill" : "ri-heart-line"
                            } w-3.5 h-3.5 flex items-center justify-center`}
                          ></i>
                          {item.likes + (liked[item.id] ? 1 : 0)}
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 space-y-6">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">讨论区数据</h3>
                <dl className="mt-4 grid grid-cols-3 gap-3">
                  {communityStats.map((stat) => (
                    <div key={stat.label} className="rounded-md bg-background-50 p-3 text-center">
                      <dt className="font-label text-[11px] text-foreground-500">{stat.label}</dt>
                      <dd className="mt-1 font-heading text-lg font-bold text-primary-700">
                        {stat.value}
                      </dd>
                    </div>
                  ))}
                </dl>
                <button
                  type="button"
                  onClick={handlePost}
                  className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
                >
                  <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                  发布整理线索
                </button>
                {postHint && (
                  <p className="mt-3 rounded-md bg-accent-100 px-3 py-2 font-label text-xs text-accent-900">
                    {postHint}
                  </p>
                )}
              </div>

              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">讨论约定</h3>
                <ul className="mt-4 space-y-3">
                  {["标注资料出处，方便他人核对", "以主题为单位发帖，避免重复", "纠错请说明理由，语气友好"].map(
                    (rule) => (
                      <li key={rule} className="flex items-start gap-2.5 text-xs leading-relaxed text-foreground-600">
                        <i className="ri-checkbox-circle-line mt-0.5 w-4 h-4 flex items-center justify-center text-secondary-500"></i>
                        {rule}
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}